export enum ErrorCode {
  EntityNotFound = 'EntityNotFound',
  VesselServiceLocationCodeInactive = 'VesselServiceLocationCodeInactive',
  ServiceIdNotUnique = 'ServiceIdNotUnique',
  NameNotUnique = 'NameNotUnique',
  ShortNameNotUnique = 'ShortNameNotUnique',
  VesselOperatorNotFound = 'VesselOperatorNotFound',
  ShippingAgentNotFound = 'ShippingAgentNotFound',
  VesselServiceNotFound = 'VesselServiceNotFound',
  DriverIdNotUnique = 'DriverIdNotUnique',
  InvalidLength = 'InvalidLength',
  TruckAlreadyOnTerminal = 'TruckAlreadyOnTerminal',
  OperatorReferenceNumberNotUnique = 'OperatorReferenceNumberNotUnique',
  ValidityDateInPast = 'ValidityDateInPast',
  EntityAlreadyExists = 'EntityAlreadyExists',
  ContainerAlreadyOnTerminal = 'ContainerAlreadyOnTerminal',
  ContainerAlreadyAssigned = 'ContainerAlreadyAssigned',
  CarrierAlreadyOnTerminal = 'CarrierAlreadyOnTerminal',
  ContainersDuplicatedInUploadFile = 'ContainersDuplicatedInUploadFile',
  ContainersAlreadyAssignedToCarrierVisit = 'ContainersAlreadyAssignedToCarrierVisit',
  ATADateInFuture = 'ATADateInFuture',
  ATBDateInFuture = 'ATBDateInFuture',
  ExitGateMismatchWarning = 'ExitGateMismatchWarning',
  ExitGateMismatchBlocked = 'ExitGateMismatchBlocked',
}
